import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { handleGetEstimateList } from './estimateThunk';
import { DEFAULT_PAGE, ROWS_PER_PAGE } from '~/utils/constants/common';
import { IParamsGetEstimateList } from '~/utils/interface/estimate';

export interface estimateState {
  openAlertModalEdit: boolean;
  openAlertModalDelete: boolean;
  mode: string;
  needRefreshData: boolean;
  filterList: IParamsGetEstimateList;
  currentPage: number;
  selectedIds: Array<string>;
  totalPages: number;
  openAlertDelete: boolean;
  menuSelectedId: string | undefined;
  estimateSelectionList: Array<string>;
}

const initialState: estimateState = {
  openAlertModalEdit: false,
  openAlertModalDelete: false,
  currentPage: DEFAULT_PAGE,
  selectedIds: [],
  openAlertDelete: false,
  menuSelectedId: undefined,
  totalPages: 0,
  mode: '',
  estimateSelectionList: [],
  needRefreshData: false,
  filterList: {
    page: 1,
    limit: ROWS_PER_PAGE,
    sort: [],
  },
};

const estimateSlice = createSlice({
  name: 'estimate',
  initialState,
  reducers: {
    changeOpenModalEdit(state, action: PayloadAction<boolean>) {
      state.openAlertModalEdit = action.payload;
    },
    setFilterList(state, action: PayloadAction<IParamsGetEstimateList>) {
      state.filterList = { ...state.filterList, ...action.payload };
    },
    changeOpenModalDelete(state, action: PayloadAction<boolean>) {
      state.openAlertModalDelete = action.payload;
    },
    changeMode(state, action: PayloadAction<string>) {
      state.mode = action.payload;
    },
    changeMenuSelectId(state, action: PayloadAction<string | undefined>) {
      state.menuSelectedId = action.payload;
    },
    changeOpenAlertDelete(state, action: PayloadAction<boolean>) {
      state.openAlertDelete = action.payload;
    },
    changeNeedRefreshData(state, action: PayloadAction<boolean>) {
      state.needRefreshData = action.payload;
    },
    changeSelectedIds(state, action: PayloadAction<Array<string>>) {
      state.selectedIds = [...action.payload];
    },
  },
  extraReducers(builder) {
    builder.addCase(handleGetEstimateList.fulfilled, (state, action) => {
      state.currentPage = action.payload.pagination.page;
      state.totalPages = action.payload.pagination.totalPages;
      state.needRefreshData = false;
    });
  },
});

export const estimateActions = estimateSlice.actions;

const estimateReducer = estimateSlice.reducer;
export default estimateReducer;
